import { initI18n } from 'www/utils'

initI18n({ bundle: 'vue_components/common/AppointmentCalendar' })
